export default __webpack_public_path__ + "static/media/dummy2.ba4560ae.webp";